import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import GuideWaveformOrb from "./GuideWaveformOrb";
import {
  getViewerActionPaddingX,
  viewerActionButtonLabelSx,
  viewerPillActionButtonSx,
  viewerSecondaryActionButtonSx,
} from "./unityWebViewer/panelStyles";

const stopStartOverlayInput = (event) => {
  event.stopPropagation();
  event.nativeEvent?.stopImmediatePropagation?.();
};

const blockStartOverlayInput = (event) => {
  if (event.cancelable) {
    event.preventDefault();
  }

  stopStartOverlayInput(event);
};

const StartGuideDialog = ({ onStartGuide, onSkip }) => {
  const isPhone = useMediaQuery("(max-width:600px)");
  const orbSize = isPhone ? 82 : 96;
  const promptWidth = isPhone ? 138 : 150;
  const actionHeight = isPhone ? 38 : 42;
  const startGuideActionSx = {
    ...viewerPillActionButtonSx,
    width: "100%",
    minHeight: actionHeight,
    px: getViewerActionPaddingX(isPhone),
  };

  return (
    <Box
      className="start-guide-overlay"
      onClick={stopStartOverlayInput}
      onContextMenu={blockStartOverlayInput}
      onDoubleClick={stopStartOverlayInput}
      onMouseDown={stopStartOverlayInput}
      onMouseMove={stopStartOverlayInput}
      onMouseUp={stopStartOverlayInput}
      onPointerCancel={stopStartOverlayInput}
      onPointerDown={stopStartOverlayInput}
      onPointerMove={stopStartOverlayInput}
      onPointerUp={stopStartOverlayInput}
      onTouchEnd={stopStartOverlayInput}
      onTouchMove={blockStartOverlayInput}
      onTouchStart={stopStartOverlayInput}
      onWheel={blockStartOverlayInput}
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: "var(--start-overlay-z-index, 2000)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
        px: 1.5,
      }}
    >
      <Box
        sx={{
          width: promptWidth,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: isPhone ? 0.9 : 1,
          pointerEvents: "auto",
          animation: "selectorIn 0.25s ease",
          "@keyframes selectorIn": {
            "0%":   { opacity: 0, transform: "scale(0.92) translateY(12px)" },
            "100%": { opacity: 1, transform: "scale(1) translateY(0)"       },
          },
        }}
      >
        <Box
          sx={{
            opacity: 0.98,
            mb: isPhone ? -0.2 : -0.35,
            pointerEvents: "none",
          }}
        >
          <GuideWaveformOrb state="DEFAULT" audioLevel={0} size={orbSize} />
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: isPhone ? 0.8 : 0.9,
          }}
        >
          <Box
            component="button"
            type="button"
            aria-label="Start guide"
            onClick={onStartGuide}
            sx={startGuideActionSx}
          >
            <Box
              component="span"
              aria-hidden="true"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 15,
                lineHeight: 1,
                transform: "translateY(-1px)",
              }}
            >
              ▶
            </Box>
            <Box
              component="span"
              className="control-label"
              sx={{
                ...viewerActionButtonLabelSx,
                fontSize: isPhone ? "13px" : "14px",
                fontWeight: 800,
                whiteSpace: "nowrap",
              }}
            >
              Start guide
            </Box>
          </Box>

          <Box
            component="button"
            type="button"
            aria-label="Not now"
            onClick={onSkip}
            sx={{
              ...viewerSecondaryActionButtonSx,
              width: "100%",
              minHeight: actionHeight,
              px: getViewerActionPaddingX(isPhone),
            }}
          >
            <Box
              component="span"
              className="control-label"
              sx={{
                ...viewerActionButtonLabelSx,
                fontSize: isPhone ? "13px" : "14px",
                fontWeight: 800,
                whiteSpace: "nowrap",
              }}
            >
              Not now
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default StartGuideDialog;
